import { render, staticRenderFns } from "./ChangePasswordMenu.vue?vue&type=template&id=4825ace3&"
import script from "./ChangePasswordMenu.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports